export default __webpack_public_path__ + "static/media/landing_page_bim_audit.5db71feb.gif";